export default __webpack_public_path__ + "static/media/big-teacher_premium_plan_flipped.0c9431b1.png";